/**
 * Returns true when value is a non-null object — including arrays, since
 * `typeof []  === 'object'` in JavaScript and arrays satisfy NonNullable<object>.
 *
 * Lives in its own file (rather than alongside the other predicates in
 * `types.ts`) so it can be imported from contexts that load TypeScript via
 * Node's strip-only loader (e.g. Vite config files), which cannot parse the
 * `enum` declarations present in `types.ts`. The inline null/undefined check
 * mirrors `isDefined()` deliberately rather than importing it, to keep this
 * file's dependency graph empty.
 */
export function isDefinedObject(value: unknown): value is NonNullable<object> {
  return value !== null && value !== undefined && typeof value === 'object';
}
